/**
 * Mock data for testing the questionnaire assignment and response functionality
 * This includes a mock Task and QuestionnaireResponse for the "Therapy Check-In" questionnaire
 */

export const MOCK_QUESTIONNAIRE = {
    resourceType: 'Questionnaire',
    id: '47553719-6951-4022-af2b-c40b47eb8405',
    meta: {
        versionId: '1',
        lastUpdated: '2026-02-15T11:48:06.131+00:00',
        profile: ['http://ehelse.no/fhir/StructureDefinition/sdf-Questionnaire'],
        security: [
            {
                system: 'urn:oid:2.16.578.1.12.4.1.1.7618',
                code: '3',
                display: 'Helsehjelp (Full)',
            },
        ],
        tag: [
            {
                system: 'urn:ietf:bcp:47',
                code: 'en-US',
                display: 'English',
            },
        ],
    },
    language: 'en-US',
    name: "Therapy Check-In: How I'm Doing Today",
    title: "Therapy Check-In: How I'm Doing Today",
    status: 'active',
    subjectType: ['Patient'],
    publisher: 'Practitioner/e17e51dc-e1e9-4a7e-ab2b-7285fe91bf50',
    description:
        'These questions should be answered at the beginning of each therapy session, to get an overview of the feeling of the patient.',
    useContext: [
        {
            code: {
                system: 'http://terminology.hl7.org/CodeSystem/usage-context-type',
                code: 'workflow',
            },
            valueCodeableConcept: {
                coding: [
                    {
                        code: 'questionnaire',
                    },
                ],
                text: 'questionnaire',
            },
        },
    ],
    item: [
        {
            linkId: 'a557bb6f-ae4f-4ebf-8187-338064498f03',
            text: 'How are you feeling today overall?',
            type: 'choice',
            required: false,
            answerOption: [
                {
                    valueCoding: {
                        id: '239a6e27-5f9b-4382-cc5a-52152dea150e',
                        system: 'urn:uuid:f9e36c90-603f-4e34-9f1a-f8f863b5704b',
                        code: 'very-good',
                        display: 'Very Good',
                    },
                },
                {
                    valueCoding: {
                        id: 'e9b53785-8dc9-4c1a-8c01-e235c00a9f30',
                        system: 'urn:uuid:f9e36c90-603f-4e34-9f1a-f8f863b5704b',
                        code: 'pretty-okay',
                        display: 'Pretty okay',
                    },
                },
                {
                    valueCoding: {
                        id: '43e67c36-2885-4295-8c5d-be2fef3023a2',
                        system: 'urn:uuid:f9e36c90-603f-4e34-9f1a-f8f863b5704b',
                        code: 'so-so',
                        display: 'So-so',
                    },
                },
                {
                    valueCoding: {
                        id: '010811ee-84c1-4079-f0df-058f55160cce',
                        system: 'urn:uuid:f9e36c90-603f-4e34-9f1a-f8f863b5704b',
                        code: 'not-so-good',
                        display: 'Not so good',
                    },
                },
                {
                    valueCoding: {
                        id: '5cf779c3-bd79-4cdd-8cac-080b3ab71c80',
                        system: 'urn:uuid:f9e36c90-603f-4e34-9f1a-f8f863b5704b',
                        code: 'really-bad',
                        display: 'Really bad',
                    },
                },
            ],
        },
        {
            linkId: 'd4ed999c-0bcb-4343-885f-c7a7e500fee6',
            text: 'What was something good about today?',
            type: 'string',
            required: false,
        },
        {
            linkId: 'a8dd77fa-6e75-42f4-e7e6-966456e627e8',
            text: 'What was hard today?',
            type: 'string',
            required: false,
        },
        {
            linkId: '066a2ed2-0ebb-482c-dbd6-3fbb6d2ff4d9',
            text: 'Did you do what your OCD wanted you to do today?',
            type: 'choice',
            required: false,
            answerOption: [
                {
                    valueCoding: {
                        id: '854e4b4f-d3d2-45ff-9e36-48fcc218f060',
                        system: 'urn:uuid:8b8cb79d-3dc0-4a8d-86c0-b0380a448fad',
                        code: 'yes,-i-did-it',
                        display: 'Yes, I did it',
                    },
                },
                {
                    valueCoding: {
                        id: '990b0da0-988e-4427-dfa4-cb700a408141',
                        system: 'urn:uuid:8b8cb79d-3dc0-4a8d-86c0-b0380a448fad',
                        code: 'a-little-bit',
                        display: 'A little bit',
                    },
                },
                {
                    valueCoding: {
                        id: '70bb1b28-c387-473e-8f42-8113302f28b2',
                        system: 'urn:uuid:8b8cb79d-3dc0-4a8d-86c0-b0380a448fad',
                        code: 'no,-i-was-stronger-than-my-ocd',
                        display: 'No, I was stronger than my OCD',
                    },
                },
            ],
        },
        {
            linkId: 'c778b255-f5ff-40e5-d93d-eb433c1704be',
            text: 'Is there anything important you want to talk about today?',
            type: 'string',
            required: false,
        },
    ],
};

export const MOCK_TASK_BUNDLE = {
    resourceType: 'Bundle',
    type: 'searchset',
    total: 1,
    entry: [
        {
            resource: {
                resourceType: 'Task',
                id: 'mock-task-therapy-checkin-001',
                meta: {
                    versionId: '2',
                    lastUpdated: '2026-02-15T14:30:00.000Z',
                },
                status: 'completed',
                intent: 'order',
                for: {
                    reference: 'Patient/mock-patient-001',
                    display: 'Nico Patient',
                },
                owner: {
                    reference: 'Patient/mock-patient-001',
                    display: 'Nico Patient',
                },
                focus: {
                    reference: 'Questionnaire/47553719-6951-4022-af2b-c40b47eb8405',
                    display: "Therapy Check-In: How I'm Doing Today",
                },
                authoredOn: '2026-02-15T09:00:00.000Z',
                lastModified: '2026-02-15T14:30:00.000Z',
                output: [
                    {
                        type: {
                            text: 'QuestionnaireResponse',
                        },
                        valueString: 'QuestionnaireResponse/mock-response-therapy-checkin-001',
                    },
                ],
            },
        },
    ],
};

export const MOCK_QUESTIONNAIRE_RESPONSE = {
    resourceType: 'QuestionnaireResponse',
    id: '47553719-6951-4022-af2b-c40b47eb8405',
    meta: {
        versionId: '1',
        lastUpdated: '2026-02-15T14:30:00.000Z',
    },
    questionnaire: 'Questionnaire/47553719-6951-4022-af2b-c40b47eb8405',
    status: 'completed',
    subject: {
        reference: 'Patient/mock-patient-001',
        display: 'Nico Patient',
    },
    authored: '2026-02-15T14:30:00.000Z',
    author: {
        reference: 'Patient/mock-patient-001',
        display: 'Nico Patient',
    },
    item: [
        {
            linkId: 'a557bb6f-ae4f-4ebf-8187-338064498f03',
            text: 'How are you feeling today overall?',
            answer: [
                {
                    valueCoding: {
                        system: 'urn:uuid:f9e36c90-603f-4e34-9f1a-f8f863b5704b',
                        code: 'pretty-okay',
                        display: 'Pretty okay',
                    },
                },
            ],
        },
        {
            linkId: 'd4ed999c-0bcb-4343-885f-c7a7e500fee6',
            text: 'What was something good about today?',
            answer: [
                {
                    valueString: 'I had a productive therapy session and completed my morning routine without anxiety.',
                },
            ],
        },
        {
            linkId: 'a8dd77fa-6e75-42f4-e7e6-966456e627e8',
            text: 'What was hard today?',
            answer: [
                {
                    valueString:
                        'I struggled with intrusive thoughts in the afternoon, but I used the techniques we discussed.',
                },
            ],
        },
        {
            linkId: '066a2ed2-0ebb-482c-dbd6-3fbb6d2ff4d9',
            text: 'Did you do what your OCD wanted you to do today?',
            answer: [
                {
                    valueCoding: {
                        system: 'urn:uuid:8b8cb79d-3dc0-4a8d-86c0-b0380a448fad',
                        code: 'a-little-bit',
                        display: 'A little bit',
                    },
                },
            ],
        },
        {
            linkId: 'c778b255-f5ff-40e5-d93d-eb433c1704be',
            text: 'Is there anything important you want to talk about today?',
            answer: [
                {
                    valueString: 'I would like to discuss strategies for handling social situations with less anxiety.',
                },
            ],
        },
    ],
};

/**
 * Flag to enable/disable mock data
 * Set to true to use mock data, false to use real API calls
 */
export const USE_MOCK_DATA = false;
